/**
 * FormCheckbox Component
 * 
 * Styled checkbox with label that can be used standalone.
 */

import React, { forwardRef } from 'react';

export interface FormCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Checkbox label */
  label: string;
  /** Additional description below the label */
  description?: string;
}

export const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ label, description, className = '', ...props }, ref) => {
    return (
      <label className={`flex items-start cursor-pointer ${className}`}>
        <input
          ref={ref}
          type="checkbox"
          className="h-4 w-4 mt-0.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          {...props}
        />
        <div className="ml-2">
          <span className="text-sm text-gray-700">{label}</span>
          {description && (
            <p className="text-xs text-gray-500">{description}</p>
          )}
        </div>
      </label>
    );
  }
);

FormCheckbox.displayName = 'FormCheckbox';
